(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["capsule-benefits-scroll"] && !Shopify.designMode) return;
  try {
    
  function initCapsuleBenefitsScroll() {
    var sections = document.querySelectorAll('.capsule-benefits');

    sections.forEach(function(section) {
      if (section.dataset.capsuleInitialized === 'true') {
        return;
      }

      section.dataset.capsuleInitialized = 'true';
      var cards = section.querySelectorAll('[data-capsule-card]');
      var navItems = section.querySelectorAll('[data-capsule-nav]');

      if (!cards.length) {
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        cards.forEach(function(card) {
          card.classList.add('is-visible');
        });
        if (navItems[0]) {
          navItems[0].classList.add('is-active');
        }
        return;
      }

      section.classList.add('capsule-benefits--ready');

      var setActive = function(index) {
        navItems.forEach(function(item) {
          item.classList.toggle('is-active', item.dataset.capsuleNav === index);
        });
      };

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var index = entry.target.dataset.capsuleCard;
            entry.target.classList.add('is-visible');
            setActive(index);
          }
        });
      }, {
        threshold: 0.38,
        rootMargin: '-12% 0px -34% 0px'
      });

      cards.forEach(function(card) {
        observer.observe(card);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCapsuleBenefitsScroll);
  } else {
    initCapsuleBenefitsScroll();
  }

  document.addEventListener('shopify:section:load', initCapsuleBenefitsScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-review-proof"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-review-count]').forEach((element) => {
    const count = Number(element.textContent.trim());
    if (Number.isFinite(count)) element.textContent = count.toLocaleString('en-AU');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-promise"] && !Shopify.designMode) return;
  try {
    
  function initQualityPromise() {
    var sections = document.querySelectorAll('.quality-promise');

    sections.forEach(function(section) {
      if (section.dataset.qualityInitialized === 'true') {
        return;
      }

      section.dataset.qualityInitialized = 'true';

      var revealItems = section.querySelectorAll('[data-quality-reveal]');

      if (!revealItems.length) {
        return;
      }

      revealItems.forEach(function(item, index) {
        item.style.setProperty('--quality-delay', index * 70 + 'ms');
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        revealItems.forEach(function(item) {
          item.classList.add('is-visible');
        });
        return;
      }

      section.classList.add('quality-promise--ready');

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.18,
        rootMargin: '0px 0px -10% 0px'
      });

      revealItems.forEach(function(item) {
        observer.observe(item);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQualityPromise);
  } else {
    initQualityPromise();
  }

  document.addEventListener('shopify:section:load', initQualityPromise);

  } catch(e) { console.error(e); }
})();
})();
